<!--
Copyright (C) 2026 Checkmk GmbH - License: Checkmk Enterprise License
This file is part of Checkmk (https://checkmk.com). It is subject to the terms and
conditions defined in the file COPYING, which is part of this source code package.
-->

<script setup lang="ts">
import AiMarkdown from '@/nonfree/ai/AiMarkdown.vue'

import type { Block } from './block'

defineProps<{ block: Block<'thinking' | 'tool_use' | 'tool_result'> }>()
</script>

<template>
  <div class="ai-block-aside">
    <AiMarkdown v-if="block.type === 'thinking'" :text="block.thinking" variant="dimmed" />
    <template v-else-if="block.type === 'tool_use'">
      {{ block.name }} {{ JSON.stringify(block.input) }}
    </template>
    <template v-else>{{ block.content }}</template>
  </div>
</template>

<style scoped>
/* Keep in sync with .ai-markdown--dimmed in AiMarkdown.vue */
.ai-block-aside {
  font-size: var(--font-size-small);
  line-height: var(--dimension-6);
  letter-spacing: 0;
  color: var(--font-color-dimmed);
}
</style>
